/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import CountCard from '../components/CountCard';
import { retrieve } from '../utils/storage_helper';

function DashboardBody({ stats }) {
    const userData = retrieve('userData') || {};
    const { user_name } = userData;
    const displayName = user_name || 'User';

    return (
        <div className="d-flex flex-column mb-4">
            <div className="mb-4">
                <h2>Hello, {displayName}</h2>
                <span>Dashboard page provides a high level statistics of your application</span>
                <hr />
            </div>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: '24px'
            }}>
                <CountCard icon="bi-cloud-download" count={20} label="Total Exports" />
                <CountCard icon="bi-table" count={60} label="Total Tables" color="#219ebc" />
            </div>
        </div>
    );
}

export default DashboardBody;
